import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TECHNICAL_TAB_ITEMS } from './technicalTabItems';
import './HeatProfilePage.css';

const TechnicalSubTabs = () => {
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleTabClick = (path) => {
        if (path !== currentPath) {
            history.push(path);
        }
    };

    return (
        <div className="heat-profile-tabs-container">
            <div className="heat-profile-tabs">
                {TECHNICAL_TAB_ITEMS.map((item) => (
                    <div
                        key={item.id}
                        className={`heat-profile-tab-item ${currentPath === item.path ? 'active' : ''}`}
                        onClick={() => handleTabClick(item.path)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleTabClick(item.path);
                            }
                        }}
                        role="tab"
                        tabIndex={0}
                        aria-selected={currentPath === item.path}
                    >
                        {item.icon}
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TechnicalSubTabs;
